import React from "react";
import Main from './pages/Main';

export default () => {
  return (
    <Main />
  );
};
